import script from "./MainView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainView.vue?vue&type=script&setup=true&lang=ts"

import "./MainView.vue?vue&type=style&index=0&id=723b8bb3&lang=scss"

const __exports__ = script;

export default __exports__